
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.301 27.98l-.871.49.871-.49zm-14.602 0l-.872-.49.872.49zm12.937-2.96l.871-.49-.871.49zM36.107 25h7.786v-2h-7.786v2zm-2.537 3.47l1.666-2.96-1.743-.98-1.666 2.96 1.743.98zM24 30h6.955v-2H24v2zm-1 19V31h-2v18h2zm33 1H24v2h32v-2zm1-19v18h2V31h-2zm-7.955-1H56v-2h-6.955v2zm-4.28-4.49l1.665 2.96 1.743-.98-1.666-2.96-1.743.98zm4.28 2.49a1 1 0 01-.872-.51l-1.743.98A3 3 0 0049.045 30v-2zM59 31a3 3 0 00-3-3v2a1 1 0 011 1h2zm-3 21a3 3 0 003-3h-2a1 1 0 01-1 1v2zm-35-3a3 3 0 003 3v-2a1 1 0 01-1-1h-2zm3-21a3 3 0 00-3 3h2a1 1 0 011-1v-2zm7.827-.51a1 1 0 01-.872.51v2a3 3 0 002.615-1.53l-1.743-.98zM43.893 25a1 1 0 01.871.51l1.743-.98A3 3 0 0043.894 23v2zm-7.786-2a3 3 0 00-2.614 1.53l1.743.98a1 1 0 01.871-.51v-2z"}}),_c('circle',{attrs:{"cx":"40","cy":"39","r":"6","fill":"none","stroke-width":"2"}})])
          )
        }
      }
    